export default {"src":"/evde-internet/_next/static/media/Dark-bkgd.074af787.svg","height":32,"width":32};